import { IUpdateUnidadesUseCase } from "../../../presentation/useCases/update/update_unidades_use_case";
import { EmpreendimentoUnidade } from "../../models/empreendimentoUnidade";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * UpdateUnidadesUseCase
 */

export class UpdateUnidadesUseCase implements IUpdateUnidadesUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async updateIncorporacaoImovel(listUnidades: EmpreendimentoUnidade[]): Promise<void> {
    await this.repository.updateUnidades(listUnidades);
  }

}
